import React, { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { login } from "../../apis";
import { useDispatch } from "react-redux";

const AdminLogin = () => {
  const pathname = useParams();
  console.log('pathname', pathname);
  

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    identifier: "", // Can be username, email, or employeeId
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ type: "", message: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  // Role-based default routes
  const getDefaultRoute = (role, userId) => {
    if (role === 'staff') {
      return '/coop-form';
    }
    
    const routes = {
      'super-admin': '/',
      'admin': '/',
      'creche': '/infants',
      'food-checker': '/food',
      'health': '/health',
      'attendance': '/',
      'staff-attendance': '/staff',
      'tab-checking': '/tablet-collection',
      'accommodation': '/accommodation',
      'camp-checkin': '/camp-status',
      'test': '/test-scores',
    };
    return routes[role] || '/';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      setAlert({ type: "", message: "" });

      // Auto-detect login type: try email first, then employeeId pattern, then username
      // EmployeeId pattern: contains "/" (e.g., "Trac/0001")
      // Email pattern: contains "@"
      // Otherwise: treat as username
      let loginData;
      const identifier = formData.identifier.trim();
      
      if (identifier.includes("@")) {
        // Looks like an email
        loginData = { email: identifier, password: formData.password };
      } else if (identifier.includes("/")) {
        // Looks like an employeeId
        loginData = { employeeId: identifier, password: formData.password };
      } else {
        // Treat as username
        loginData = { username: identifier, password: formData.password };
      }

      const response = await login(loginData);
      console.log('response from login', response);
      
      if (response?.status === 200) {
        setAlert({
          type: "success",
          message: "Login successful! Redirecting...",
        });
        localStorage.setItem("token", response.data.token);
        dispatch({
          type: "USER_LOGIN_SUCCESS",
          payload: {
            token: response.data.token,
            userInfo: {
              role: response.data.role,
              id: response.data.userId,
            },
          },
        });
        
        // Handle redirection: return to shared/deep link, user page, or role default
        const from = location.state?.from;
        if (from?.pathname) {
          navigate(`${from.pathname}${from.search || ""}`, { replace: true });
        } else if (pathname?.user) {
          navigate(`/admin/user/${pathname?.user}`);
        } else {
          const defaultRoute = getDefaultRoute(
            response?.data?.role,
            response?.data?.userId
          );
          navigate(defaultRoute, { replace: true });
        }
      } else {
        setAlert({
          type: "error",
          message: response?.data?.message || "Login failed. Please try again.",
        });
      }
    } catch (error) {
      setAlert({
        type: "error",
        message: error?.message || "Login failed. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login__container">
        <div className="admin-login__header">
          <div className="admin-login__header-logo">
            {/* <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
            </svg> */}
          </div>
          <h1 className="admin-login__header-title">Login</h1>
          <p className="admin-login__header-subtitle">
            Enter your username, email, or employee ID, and password to access the system
          </p>
        </div>

        {alert.message && (
          <div
            className={`admin-login__alert admin-login__alert--${alert.type}`}
          >
            {alert.message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="admin-login__form">
          <div className="admin-login__form-group">
            <label className="admin-login__form-label">Username / Email / Employee ID</label>
            <input
              type="text"
              name="identifier"
              value={formData.identifier}
              onChange={handleChange}
              className={`admin-login__form-input ${
                errors.identifier ? "admin-login__form-input--error" : ""
              }`}
              required
              placeholder="Enter username, email, or employee ID (e.g., Trac/0001)"
            />
            {errors.identifier && (
              <p className="admin-login__form-error">{errors.identifier}</p>
            )}
          </div>

          <div className="admin-login__form-group">
            <label className="admin-login__form-label">Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className={`admin-login__form-input ${
                errors.password ? "admin-login__form-input--error" : ""
              }`}
              required
              placeholder="Enter your password"
            />
            {errors.password && (
              <p className="admin-login__form-error">{errors.password}</p>
            )}
          </div>

          {/* <a href="/forgot-password" className="admin-login__form-forgot">
            Forgot password?
          </a> */}

          <button
            type="submit"
            className="admin-login__form-submit"
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
